export const DEFAULT_HEADER_ID = 'header'
export const DEFAULT_CONTENT_ID = 'content'
export const DEFAULT_FOOTER_ID = 'footer'
export const INITIAL_HEADER_HEIGHT = {
  xs: 56,
  sm: 64,
};
export const EDGE_SIDEBAR_EXPAND_DELAY = 350
export const CSS_TRANSITION = 'all 300ms cubic-bezier(0.0, 0, 0.2, 1) 0ms, color 0s'
